// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import { Money } from '../protos/demo';

export interface IProductMeta {
  rating: number;
  reviewCount: number;
  badge: string;
}

const badgeByBucket: Record<number, string> = {
  0: 'Bestseller',
  1: 'Bestseller',
  3: 'New',
  4: 'New',
  5: 'Sale',
  6: 'Staff pick',
  7: 'Low stock',
};

export const productBadges = ['Bestseller', 'New', 'Sale', 'Staff pick', 'Low stock'];

export const badgeSlug = (badge: string) => badge.toLowerCase().replace(/\s+/g, '-');

export const getProductMeta = (id: string): IProductMeta => {
  const hash = id.split('').reduce((acc, char, index) => acc + char.charCodeAt(0) * (index + 7), 0);
  return {
    rating: 4 + (hash % 10) / 10,
    reviewCount: 14 + (hash % 180),
    badge: badgeByBucket[hash % 10] ?? '',
  };
};

export const getCompareAtPrice = (price: Money): Money => {
  const totalNanos = Math.round((Number(price.units) * 1e9 + Number(price.nanos)) * 1.3);
  return {
    currencyCode: price.currencyCode,
    units: Math.floor(totalNanos / 1e9),
    nanos: totalNanos % 1e9,
  };
};
